import React from 'react'
import styled from '@emotion/styled'
import CoachVideoConversation from './CoachVideoConversation'
import CoachAudioConversation from './CoachAudioConversation'

const MediaContainer = styled.div`
  grid-area: content;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
`

/**
 * CoachMediaWrap component - container for video and audio conversation components
 * Based on the candidate media wrap but adapted for coach use
 *
 * @param {Object} props
 * @param {string} props.chatMode - Current chat mode (text, audio, video)
 * @param {Object} props.candidate - The candidate being chatted with
 */
const CoachMediaWrap = ({ chatMode, candidate, bgEffectsEnabled = false }) => {
  if (chatMode === 'text') {
    return null
  }

  return (
    <MediaContainer>
      {chatMode === 'video' && (
        <CoachVideoConversation
          candidate={candidate}
          bgEffectsEnabled={bgEffectsEnabled}
        />
      )}

      {chatMode === 'audio' && <CoachAudioConversation candidate={candidate} />}
    </MediaContainer>
  )
}

export default CoachMediaWrap
